import React from 'react'
import './index.scss'
import imgInstru from "../../../../assets/images/Event-2025/title-instruc.png";
import bgTopLeft from "../../../../assets/images/Event-2025/img-top-left.png";
import bgTopRight from "../../../../assets/images/Event-2025/img-top-right.png";
import bgBot from "../../../../assets/images/Event-2025/Frame (4).png";
import bgBotLeft from "../../../../assets/images/Event-2025/img-bot-left.png";
import bgBotRight from "../../../../assets/images/Event-2025/img-bot-right.png";

export default function Instruction() {
  return (
    <div className="event-2024-tab-rank">
      <div className="rank_top">
        <div className='rank_top_title'>
            <img src={imgInstru} alt="" />
        </div>
      </div>
      <div className="instru_rank">
        <div className="instru_rank_text">
          <strong>Navidad Explosiva</strong>
          <br />
          <p>Duración: 15 de noviembre - 15 de diciembre</p>
          <br />
          <strong>Concurso Navidad Explosiva:</strong>
          <p>- Los jugadores compiten para crear la mayor cantidad de espectáculos de fuegos artificiales.</p>
          <p>- Los 3 mejores jugadores ganarán 3 premios de alto valor en orden:</p>
          <p>1er premio: PREMIO EN EFECTIVO DE S/.1500</p>
          <p>2do premio: CELULAR XIAOMI REDMI 13 128GB, 6GB RAM (S/.1,399)</p>
          <p>3er premio: CELULAR XIAOMI REDMI A3 4G 64GB 3GB RAM (S/.1,199)</p>
          <p>- El concurso finaliza a las 23: 59: 59 del 15 de diciembre de 2025.</p>
          <p>- Si los jugadores crean el mismo número de fuegos artificiales, la clasificación se basará en el jugador que logró ese número primero.</p>
          <p>- Si aún hay empate, la clasificación se basará en el número de fuegos artificiales apagados.</p>
          <br />
          <strong>Árbol de Navidad:</strong>
          <p>- Hay 10 premios especiales Giftcards de S/.100.</p>
          <p>- Cada jugador recibe 3 Cajas Navideñas gratis todos los días y estas cajas no son acumulables.</p>
          <p>- Cada vez que se alcanzan las metas del Espectáculo de Fuegos Artificiales (50, 100 y más), los usuarios reciben Súper Cajas Navideñas que tienen una mayor probabilidad de grandes premios que las Cajas Navideñas normales. Por lo tanto, la probabilidad de ganar las giftcards de S/.100 es más alto.</p>
          <p>- El ganador será elegido cuando se otorgue el premio. </p>
          <p>- Después de que se otorguen los 10 premios, el sistema anunciará que los premios de las Giftcards de S/. 100 se han agotado.</p>
          <p>- Incluye Caja Navideña Normal:</p>
          <p>3, 5 o 10 Fósforos.</p>
          <p>3, 5 o 10 Conchas de fuegos artificiales</p>
          <p>3 o 5 pujas gratuitas</p>
          <p>Giftcards de S/. 100</p>
          <br />
          <p>Campana Dorada: Buena suerte</p>
          <p>- Super Caja Navideña incluye:</p>
          <p>10 Fósforos.</p>
          <p>10 Conchas de fuegos artificiales</p>
          <p>3 o 5 pujas gratuitas</p>
          <p>Giftcards de S/. 100</p>
          <br />
          <strong>Después de que termine el evento:</strong>
          <p>- El sistema actualizará y finalizará automáticamente la lista de ganadores de 13 premios.</p>
          <p>- Bitel se pondrá en contacto con los ganadores para concertar el premio de acuerdo con la normativa habitual.</p>
          <br />
          <strong>Cómo crear un Espectáculos de Fuegos Artificiales:</strong>
          <p>- Para crear un Espectáculo de Fuegos Artificiales, los jugadores deben combinar 1 Fósforo y 1 Fuegos Artificial.</p>
          <p>- Los fósforos se recolectan mediante las pujas, cada puja dará una recompensa sorpresa de 3 fósforos.</p>
          <p>- Los proyectiles de fuegos artificiales se pueden recolectar comprando o renovando paquetes específicos:</p>
          <p>La compra o renovación del Paquete Diario dará 5 Fuegos Artificiales, el Paquete Semanal dará 10 Fuegos Artificiales y el Paquete Mensual dará 50 Fuegos Artificiales.Además, los jugadores pueden comprar paquetes especiales para obtener Fuegos Artificiales que dan las siguientes recompensas:</p>
          <p>CHANCE1 - 2 Conchas de fuegos artificiales</p>
          <p>CHANCE2 - 5 Conchas de fuegos artificiales</p>
          <p>CHANCE5 -15 Conchas de fuegos artificiales</p>
          <p>CHANCE10 - 25 Conchas de fuegos artificiales</p>        
          <br />
          <br />  
        </div>
        <div className="bg_top_left">
          <img src={bgTopLeft} alt="" />
        </div>
        <div className="bg_top_right">
          <img src={bgTopRight} alt="" />
        </div>
        <div className="bg_bot">
          <img src={bgBot} alt="" />
        </div>
      </div>
      <div className="bg_bot_left">
        <img src={bgBotLeft} alt="" />
      </div>
      <div className="bg_bot_right">
        <img src={bgBotRight} alt="" />
      </div>
    </div>
  )
}
